@if (isBusy()) {
  <div class="busyIndicator">
    <div class="busyContents">
      <mat-progress-spinner diameter="48" mode="indeterminate"></mat-progress-spinner>
      <label class="busyLabel">Please Wait...</label>
    </div>
  </div>
}
<div class="content">
  <div class="toolbar">
    <button matButton="text" class="leftToolbarButton" [disabled]="isBusy()" (click)="openHelpDialog()">
      <span>
        <mat-icon>help</mat-icon>
        <label class="buttonLabel">Help</label>
      </span>
    </button>
    <span class="spacer"></span>
    <span>
      <label class="quantityLabel">Release Quantity: {{ releaseQuantity }}</label>
      <button matButton="text" [disabled]="isBusy() || releaseQuantity === 0" (click)="generateRelease()">
        <span>
          <mat-icon>done</mat-icon>
          <label class="buttonLabel">Generate Release</label>
        </span>
      </button>
    </span>
  </div>
  <div class="inputRow">
    <mat-form-field class="descriptionFilter">
      <mat-label>Description Filter</mat-label>
      <input matInput [(ngModel)]="descriptionFilter" (keyup)="filterList()">
    </mat-form-field>
    <mat-form-field class="taggingFilter">
      <mat-label>Building Filter</mat-label>
      <mat-select [(ngModel)]="buildingFilters" (selectionChange)="filterList()" multiple>
        @for (value of buildingValues(); track value) {
          <mat-option [value]="value">{{ value }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
    <mat-form-field class="taggingFilter">
      <mat-label>Floor Filter</mat-label>
      <mat-select [(ngModel)]="floorFilters" (selectionChange)="filterList()" multiple>
        @for (value of floorValues(); track value) {
          <mat-option [value]="value">{{ value }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
    <mat-form-field class="taggingFilter">
      <mat-label>Riser Filter</mat-label>
      <mat-select [(ngModel)]="riserFilters" (selectionChange)="filterList()" multiple>
        @for (value of riserValues(); track value) {
          <mat-option [value]="value">{{ value }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
    <mat-form-field class="taggingFilter">
      <mat-label>Room Filter</mat-label>
      <mat-select [(ngModel)]="roomFilters" (selectionChange)="filterList()" multiple>
        @for (value of roomValues(); track value) {
          <mat-option [value]="value">{{ value }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
    <mat-form-field class="taggingFilter">
      <mat-label>Tag Filter</mat-label>
      <mat-select [(ngModel)]="tagFilters" (selectionChange)="filterList()" multiple>
        @for (value of tagValues(); track value) {
          <mat-option [value]="value">{{ value }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
    <span class="spacer"></span>
    <mat-paginator #paginator [pageSizeOptions]="[25, 50, 100]" [pageSize]="25"
    [showFirstLastButtons]=true></mat-paginator>
  </div>
  <div class="inputRow">
    <span class="spacer"></span>
    <mat-checkbox class="checkboxInput" (change)="filterList()" [(ngModel)]="unreleasedOnly">Only show
      unreleased entries
    </mat-checkbox>
    <mat-form-field class="dateInput">
      <mat-label>Unit release date</mat-label>
      <input matInput [matDatepicker]="unitDatePicker" [(ngModel)]="unitDate">
      <mat-datepicker-toggle matSuffix [for]="unitDatePicker"></mat-datepicker-toggle>
      <mat-datepicker #unitDatePicker></mat-datepicker>
    </mat-form-field>
    <mat-form-field class="dateInput">
      <mat-label>Riser release date</mat-label>
      <input matInput [matDatepicker]="riserDatePicker" [(ngModel)]="riserDate">
      <mat-datepicker-toggle matSuffix [for]="riserDatePicker"></mat-datepicker-toggle>
      <mat-datepicker #riserDatePicker></mat-datepicker>
    </mat-form-field>
    <mat-form-field class="dateInput">
      <mat-label>FO release date</mat-label>
      <input matInput [matDatepicker]="foDatePicker" [(ngModel)]="foDate">
      <mat-datepicker-toggle matSuffix [for]="foDatePicker"></mat-datepicker-toggle>
      <mat-datepicker #foDatePicker></mat-datepicker>
    </mat-form-field>
    <mat-form-field class="thermostatDateInput">
      <mat-label>Thermostat release date</mat-label>
      <input matInput [matDatepicker]="thermostatDatePicker" [(ngModel)]="thermostatDate">
      <mat-datepicker-toggle matSuffix [for]="thermostatDatePicker"></mat-datepicker-toggle>
      <mat-datepicker #thermostatDatePicker></mat-datepicker>
    </mat-form-field>
  </div>
  <div class="detailResults">
    <table mat-table [dataSource]="datasource" matSort class="paginatedTable bordered-table">
      <ng-container matColumnDef="select">
        <th mat-header-cell *matHeaderCellDef>
          <mat-checkbox (change)="$event ? masterToggle() : null"
            [checked]="selection() && selection().hasValue() && isAllSelected()"
            [indeterminate]="selection() && selection().hasValue() && !isAllSelected()">
          </mat-checkbox>
        </th>
        <td mat-cell *matCellDef="let row">
          <mat-checkbox [disabled]="row.released" (click)="$event.stopPropagation()"
            (change)="$event ? toggleRowSelection(row) : null" [checked]="selection().isSelected(row)">
          </mat-checkbox>
        </td>
      </ng-container>
      <ng-container matColumnDef="lineId">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Line #</th>
        <td mat-cell *matCellDef="let line">{{ line.lineId }}</td>
      </ng-container>
      <ng-container matColumnDef="description">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Description</th>
        <td mat-cell *matCellDef="let line">{{ line.description }}</td>
      </ng-container>
      <ng-container matColumnDef="building">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Building</th>
        <td mat-cell *matCellDef="let line">{{ line.building }}</td>
      </ng-container>
      <ng-container matColumnDef="floor">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Floor</th>
        <td mat-cell *matCellDef="let line">{{ line.floor }}</td>
      </ng-container>
      <ng-container matColumnDef="riser">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Riser</th>
        <td mat-cell *matCellDef="let line">{{ line.riser }}</td>
      </ng-container>
      <ng-container matColumnDef="room">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Room</th>
        <td mat-cell *matCellDef="let line">{{ line.room }}</td>
      </ng-container>
      <ng-container matColumnDef="tag">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Tag</th>
        <td mat-cell *matCellDef="let line">{{ line.tag }}</td>
      </ng-container>
      <ng-container matColumnDef="unitReleaseDate">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Unit Date</th>
        <td mat-cell *matCellDef="let line">{{ line.unitReleaseDate }}</td>
      </ng-container>
      <ng-container matColumnDef="unitErpOrderNumber">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Unit Order #</th>
        <td mat-cell *matCellDef="let line">{{ line.unitErpOrderNumber }}</td>
      </ng-container>
      <ng-container matColumnDef="riserReleaseDate">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Riser Date</th>
        <td mat-cell *matCellDef="let line">{{ line.riserReleaseDate }}</td>
      </ng-container>
      <ng-container matColumnDef="riserErpOrderNumber">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Riser Order #</th>
        <td mat-cell *matCellDef="let line">{{ line.riserErpOrderNumber }}</td>
      </ng-container>
      <ng-container matColumnDef="foReleaseDate">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>FO Date</th>
        <td mat-cell *matCellDef="let line">{{ line.foReleaseDate }}</td>
      </ng-container>
      <ng-container matColumnDef="foErpOrderNumber">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>FO Order #</th>
        <td mat-cell *matCellDef="let line">{{ line.foErpOrderNumber }}</td>
      </ng-container>
      <ng-container matColumnDef="thermostatReleaseDate">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>T-stat Date</th>
        <td mat-cell *matCellDef="let line">{{ line.thermostatReleaseDate }}</td>
      </ng-container>
      <ng-container matColumnDef="thermostatErpOrderNumber">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>T-stat Order #</th>
        <td mat-cell *matCellDef="let line">{{ line.thermostatErpOrderNumber }}</td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr [class.releasedRow]="row.released" [class.clickableRow]="!row.released"
        [class.selectedRow]="selection().isSelected(row)" mat-row
      *matRowDef="let row; columns: displayedColumns;" (click)="toggleRowSelection(row)"></tr>
    </table>
  </div>
</div>
@if (errorMessage()) {
  <div class="errorMessage">
    <pre>{{ errorMessage() }}</pre>
  </div>
}
